import React from 'react'
import { Redirect } from 'react-router-dom'

import LocationDetailPage from './page'

const locations = ['jakarta', 'singapore']

const images = {
  jakarta: 'https://d2u7nrdrppwhsn.cloudfront.net/career/indonesia.jpg',
  singapore: 'https://d2u7nrdrppwhsn.cloudfront.net/career/singapore.jpg',
}

export default props => {
  const locationId = props.match.params.locationId
  if (locations.includes(locationId)) {
    return <LocationDetailPage background={images[locationId]} />
  }

  return <Redirect to='/404' />
}
